import { Box } from "@mui/material";
import { capitalizeFirstLetter } from "../../utils/utils";

const getColumns = () => {
  return [
    {
      accessorKey: "user_name",
      header: "User Name",
      minSize: 200,
      grow: true,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }: { row: any }) => {
        const firstName = row.original.firstName;
        const lastName = row.original.lastName;
        const userEmail = row.original.email;
        const profileOrgId = row.original.profileOrgId;
        const userName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
        const handleNameClick = () => {
        row.original?.onNameClick(userEmail, true, userName, profileOrgId);
      };
        return <Box className="flex flex-row gap-1 justify-center"
              sx={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
                alignContent: "flex-start",
                padding: "4px 8px",
              }}
            >
                <span
                style={{
                    flexGrow: 0,
                    flexShrink: 1,
                    flexBasis: "auto",
                    textDecoration: "underline",
                    textDecorationColor: "rgba(25, 118, 210, 0.4)",
                    color: "#1976d2",
                    cursor: "pointer",
                  }}
                  onClick={handleNameClick}
                >
              {userName}
                </span>
            </Box>
      },
    },
    {
      accessorKey: "email",
      header: "Email",
      minSize: 300,
      grow: true,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }: { row: any }) => {
        const email = row.original.email;
        return <span>{email}</span>;
      },
    },
    {
      accessorKey: "account",
      header: "Account",
      minSize: 200,
      grow: true,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }: { row: any }) => {
        const accounts = row.original.accounts;
        return <span>{capitalizeFirstLetter(accounts)}</span>;
      },
    },
    {
      accessorKey: "isActive",
      header: "Active Status",
      minSize: 100,
      grow: true,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ cell }: { cell: any }) => {
        const active: boolean = cell.getValue();
           return <span>{active ? "Active" : "Inactive"}</span>;
        },
    },
  ];
};

export { getColumns };
